import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'
import { useState } from 'react'
import { AsyncAutocompleteProps } from './AsyncAutocompleteDefinitions'

const AsyncAutocomplete = (props: AsyncAutocompleteProps) => {
  const { value, options, onChange, onBlur, style, ...rest } = props
  const [open, setOpen] = useState(false)
  const loading = open && options?.length === 0

  return (
    <Autocomplete
      {...rest}
      disablePortal
      id="async-demo"
      options={options}
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      loading={loading}
      value={value}
      style={style || {}}
      disabled={rest.disabled}
      onChange={(_, value) => !rest.disabled && onChange(value)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
      groupBy={props.groupBy}
    />
  )
}

export default AsyncAutocomplete